import { Box, CircularProgress, Container, FormControlLabel, Grid, Switch, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { get, post } from "src/utils/networkUtils";
import { AppWidgetSummary } from "../sections/@dashboard/app";

export default function DashboardPage() {
	const [scoringStats, setScoringStats] = useState(null);
	const [toggle, setToggle] = useState(null);
	const [loading, setLoading] = useState(false);
	useEffect(() => {
		get(`/admin/scoring/stats`).then((response) => {
			setScoringStats(response);
			setToggle(response.scoringEnabled);
		});
	}, []);
	const handleChangeToggle = (event) => {
		setToggle(event.target.checked);
		setLoading(true);
		post(`/admin/scoring`, {
			enable: event.target.checked,
		}).then((response) => {
			window.location.reload(false);
		});
	};
	console.log(scoringStats);
	return (
		<>
			<Helmet>
				<title> Scoring Entries </title>
			</Helmet>

			<Container maxWidth="xl">
				<Typography variant="h4" sx={{ mb: 5 }}>
					Scoring Entries
				</Typography>
				{scoringStats === null || loading ? (
					<Box sx={{ display: "flex", justifyContent: "center" }} style={{ padding: 20 }}>
						<CircularProgress />
					</Box>
				) : (
					<>
						<Box sx={{ p: 2 }}>
							{toggle !== null && (
								<FormControlLabel control={<Switch checked={toggle} onChange={handleChangeToggle} />} label="Run Scoring" />
							)}
						</Box>
						<Grid container spacing={3}>
							<Grid item xs={12} sm={6} md={4}>
								<AppWidgetSummary title="All Entries" total={scoringStats.allEntriesCount} icon={"eva:list-outline"} />
							</Grid>

							<Grid item xs={12} sm={6} md={4}>
								<AppWidgetSummary title="In Progress" total={scoringStats.inProgressCount} color="info" icon={"eva:sync-outline"} />
							</Grid>

							<Grid item xs={12} sm={6} md={4}>
								<AppWidgetSummary title="Scored Entries" total={scoringStats.finishedCount} color="warning" icon={"eva:lock-outline"} />
							</Grid>
						</Grid>
					</>
				)}
			</Container>
		</>
	);
}
